/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPill = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M20.23 3.618a5.702 5.702 0 0 0-8.063 0l-8.55 8.549a5.702 5.702 0 1 0 8.064 8.063l8.55-8.549a5.702 5.702 0 0 0 0-8.063zm-6.649 1.414a3.702 3.702 0 1 1 5.235 5.235l-3.567 3.567L10.013 8.6zm-1.495 9.26 1.414 1.415L9.707 19.5l-1.414-1.414z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgPill as Pill };
